import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";

// const token = localStorage.getItem("token");

// const getConfig = () => {
//   return {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   };
// };
export const getVenderListServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "vender/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const getVendorDetailsServ = async (id) => {
  try {
    const response = await axios.get(BASE_URL + "vender/details/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const updateVendorProfile = async (formData) => {
  try {
    const response = await axios.put(BASE_URL + "vender/update", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteVendorServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "vender/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
